interface ToastConfig {
  variant: "default" | "destructive";
  description: string;
  duration: number;
  closeOnClick: boolean;
  title?: string;
}

interface MessageCategory {
  SUCCESS: ToastConfig;
  ERROR: ToastConfig;
}

interface Messages {
  CREATE: MessageCategory;
  UPDATE: MessageCategory;
  DISABLED: MessageCategory;
  DEACTIVATE: MessageCategory;
  REACTIVATE: MessageCategory;
}

export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Regional criada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar regional.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Regional atualizada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar regional.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DISABLED: {
    SUCCESS: {
      variant: "default",
      description: "Operação realizada com sucesso na regional!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao realizar a operação na regional.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DEACTIVATE: {
    SUCCESS: {
      variant: "default",
      title: "Regional desativado!",
      description: "Regional desativado com sucesso.",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      title: "Erro ao desativar regional",
      description: "Erro desconhecido",
      duration: 5000,
      closeOnClick: true,
    },
  },
  REACTIVATE: {
    SUCCESS: {
      variant: "default",
      title: "Regional reativado!",
      description: "Regional reativado com sucesso.",
      duration: 3000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      title: "Erro ao reativar regional",
      description: "Não foi possível reativar o regional.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};